import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function CartSidebar() {
  const { items, removeItem, updateQty, total, isOpen, setIsOpen } = useCart();
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="cart-overlay" onClick={() => setIsOpen(false)}>
      <div className="cart-panel" onClick={e => e.stopPropagation()}>
        <div className="cart-header">
          <span className="cart-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            עגלת קניות
          </span>
          <button className="close-btn" onClick={() => setIsOpen(false)}>✕</button>
        </div>

        {items.length === 0 ? (
          <div className="empty-state">
            <div className="icon">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                <path d="M15 45 L45 15" stroke="var(--primary)" strokeWidth="4" strokeLinecap="round"
                  strokeDasharray="50" className="loading-pencil"/>
                <path d="M45 15 L50 10 L55 20 L45 15" fill="var(--purple)" stroke="var(--purple)" strokeWidth="1"/>
                <path d="M15 45 L10 55 L20 50 Z" fill="#e8c97a"/>
              </svg>
            </div>
            <p>העגלה ריקה</p>
          </div>
        ) : (
          <>
            <div style={{ flex: 1 }}>
              {items.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-img">
                    {item.image
                      ? <img src={item.image} alt={item.name} />
                      : '🎨'}
                  </div>
                  <div className="cart-item-info">
                    <div className="cart-item-name">{item.name}</div>
                    <div className="cart-item-price">₪{((item.sale_price || item.price) * item.quantity).toFixed(2)}</div>
                    <div className="qty-controls">
                      <button className="qty-btn" onClick={() => updateQty(item.id, item.quantity - 1)}>−</button>
                      <span>{item.quantity}</span>
                      <button className="qty-btn" onClick={() => updateQty(item.id, item.quantity + 1)}>+</button>
                      <button className="remove-btn" onClick={() => removeItem(item.id)}>🗑</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-total">סה"כ: ₪{total.toFixed(2)}</div>
            <button className="checkout-btn" onClick={() => { setIsOpen(false); navigate('/checkout'); }}>
              המשך להזמנה ←
            </button>
          </>
        )}
      </div>
    </div>
  );
}
